module.exports = __webpack_public_path__ + "static/hab_research_3-0641fee67a7b6f968227d4c786c0fe1f.png";